export default "__VITE_ASSET__CeAHDRux__"